import { render, staticRenderFns } from "./ActivityRecord.vue?vue&type=template&id=621673c0&scoped=true"
import script from "./ActivityRecord.vue?vue&type=script&lang=js"
export * from "./ActivityRecord.vue?vue&type=script&lang=js"
import style0 from "./ActivityRecord.vue?vue&type=style&index=0&id=621673c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621673c0",
  null
  
)

export default component.exports